(function () {
  function formatMoney(cents, currencyCode) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode || 'USD',
      minimumFractionDigits: 2,
    }).format((Number(cents) || 0) / 100);
  }

  function formatStepLabel(step) {
    return step
      .split('_')
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  function buildSummaryMarkup(items, currencyCode) {
    return items
      .map(function (item) {
        var priceText = item.price > 0 ? '+' + formatMoney(item.price, currencyCode) : 'Included';
        return [
          '<div class="stark-configurator__summary-item">',
          '<span class="stark-configurator__summary-key">' + item.key + '</span>',
          '<span class="stark-configurator__summary-value">' + item.value + '</span>',
          '<span class="stark-configurator__summary-price">' + priceText + '</span>',
          '</div>',
        ].join('');
      })
      .join('');
  }

  function updateStarkConfiguratorOrderOffsets() {
    var footerGroup = document.querySelector('.shopify-section-group-footer-group');
    var overlap = footerGroup ? Math.max(0, window.innerHeight - footerGroup.getBoundingClientRect().top) : 0;

    Array.prototype.slice.call(document.querySelectorAll('.stark-configurator__order-row')).forEach(function (orderRow) {
      orderRow.style.setProperty('--stark-configurator-order-offset', overlap + 'px');
    });
  }

  var starkConfiguratorOrderOffsetFrame = null;

  function requestStarkConfiguratorOrderOffsetUpdate() {
    if (starkConfiguratorOrderOffsetFrame) {
      return;
    }

    starkConfiguratorOrderOffsetFrame = window.requestAnimationFrame(function () {
      starkConfiguratorOrderOffsetFrame = null;
      updateStarkConfiguratorOrderOffsets();
    });
  }

  if (!window.__starkConfiguratorOrderOffsetBound) {
    window.__starkConfiguratorOrderOffsetBound = true;
    window.addEventListener('scroll', requestStarkConfiguratorOrderOffsetUpdate, { passive: true });
    window.addEventListener('resize', requestStarkConfiguratorOrderOffsetUpdate);
    window.addEventListener('load', requestStarkConfiguratorOrderOffsetUpdate);
  }

  function initConfigurator(configurator) {
    var basePrice = Number(configurator.dataset.basePrice || 0);
    var currencyCode = configurator.dataset.currencyCode || 'USD';
    var tabs = Array.prototype.slice.call(configurator.querySelectorAll('[data-config-tab]'));
    var panels = Array.prototype.slice.call(configurator.querySelectorAll('[data-step-panel]'));
    var options = Array.prototype.slice.call(configurator.querySelectorAll('[data-config-option]'));
    var contextToggles = Array.prototype.slice.call(configurator.querySelectorAll('[data-config-context]'));
    var prevButton = configurator.querySelector('[data-config-prev]');
    var nextButton = configurator.querySelector('[data-config-next]');
    var carousels = Array.prototype.slice.call(configurator.querySelectorAll('[data-config-carousel]'));
    var orderForm = configurator.querySelector('.stark-configurator__order-card');
    var orderButton = orderForm ? orderForm.querySelector('.stark-configurator__order-button') : null;
    var stageImage = configurator.querySelector('[data-stage-image]');
    var stageOverlay = configurator.querySelector('[data-stage-overlay]');
    var stagePower = configurator.querySelector('[data-stage-power]');
    var stagePowerValue = configurator.querySelector('[data-stage-power-value]');
    var totalTargets = Array.prototype.slice.call(configurator.querySelectorAll('[data-config-total-price]'));
    var leasingTotalInput = configurator.querySelector('[data-leasing-total-cents]');
    var propertyInputs = Array.prototype.slice.call(configurator.querySelectorAll('[data-property-input]'));
    var choiceTargets = Array.prototype.slice.call(configurator.querySelectorAll('[data-current-choice]'));
    var summaryTargets = Array.prototype.slice.call(configurator.querySelectorAll('[data-summary-list]'));
    var horizontalRows = Array.prototype.slice.call(
      configurator.querySelectorAll(
        '.stark-configurator__tab-rail, .stark-configurator__pill-row, .stark-configurator__compact-option-list, .stark-configurator__mode-row, .stark-configurator__tile-grid'
      )
    );
    var summaryImages = {
      color: configurator.querySelector('[data-summary-image="color"]'),
      power: configurator.querySelector('[data-summary-image="power"]'),
      rear_brake: configurator.querySelector('[data-summary-image="rear_brake"]'),
      suspension: configurator.querySelector('[data-summary-image="suspension"]'),
      sidestand: configurator.querySelector('[data-summary-image="sidestand"]'),
    };
    var activeStepIndex = 0;
    var lastChangedOptions = {};
    var lastChangedContextOptions = {};
    var horizontalRowsFrame = null;

    function syncHorizontalRow(row) {
      if (!row) {
        return;
      }

      if (!row.clientWidth) {
        row.classList.remove('is-scrollable');
        return;
      }

      row.classList.toggle('is-scrollable', row.scrollWidth > row.clientWidth + 2);
    }

    function syncHorizontalRows() {
      horizontalRows.forEach(syncHorizontalRow);
    }

    function requestHorizontalRowsSync() {
      if (horizontalRowsFrame) {
        return;
      }

      horizontalRowsFrame = window.requestAnimationFrame(function () {
        horizontalRowsFrame = null;
        syncHorizontalRows();
      });
    }

    function scrollIntoConfiguratorView(element) {
      if (!element || typeof element.scrollIntoView !== 'function') {
        return;
      }

      element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    function getStepOrder() {
      return tabs.map(function (tab) {
        return tab.dataset.configTab;
      });
    }

    function getSelectedOptions(step) {
      return options.filter(function (option) {
        return option.dataset.step === step && option.classList.contains('is-selected');
      });
    }

    function getStepOptions(step) {
      return options.filter(function (option) {
        return option.dataset.step === step;
      });
    }

    function getStepContextToggles(step) {
      return contextToggles.filter(function (toggle) {
        return toggle.dataset.step === step;
      });
    }

    function getActiveContext(step) {
      var activeToggle = getStepContextToggles(step).find(function (toggle) {
        return toggle.classList.contains('is-active');
      });

      return activeToggle ? activeToggle.dataset.context : '';
    }

    function syncContextVisibility(step) {
      var stepOptions = getStepOptions(step);
      var activeContext = getActiveContext(step);

      if (!stepOptions.some(function (option) {
        return !!option.dataset.context;
      })) {
        return;
      }

      stepOptions.forEach(function (option) {
        var isVisible = !activeContext || !option.dataset.context || option.dataset.context === activeContext;

        option.hidden = !isVisible;
        option.classList.toggle('is-hidden', !isVisible);
      });

      var selectedVisible = stepOptions.filter(function (option) {
        return !option.hidden && option.classList.contains('is-selected');
      });

      if (selectedVisible.length) {
        stepOptions.forEach(function (option) {
          if (option !== selectedVisible[0]) {
            option.classList.remove('is-selected');
          }
        });
        return;
      }

      var contextOptionKey = activeContext ? lastChangedContextOptions[step + ':' + activeContext] : null;
      var nextSelected = stepOptions.find(function (option) {
        return !option.hidden && contextOptionKey && (option.dataset.value || option.dataset.label) === contextOptionKey;
      });

      if (!nextSelected) {
        nextSelected = stepOptions.find(function (option) {
          return !option.hidden && lastChangedOptions[step] && (option.dataset.value || option.dataset.label) === lastChangedOptions[step];
        });
      }

      if (!nextSelected) {
        nextSelected = stepOptions.find(function (option) {
          return !option.hidden;
        });
      }

      if (!nextSelected) {
        return;
      }

      stepOptions.forEach(function (option) {
        option.classList.remove('is-selected');
      });

      nextSelected.classList.add('is-selected');
      lastChangedOptions[step] = nextSelected.dataset.value || nextSelected.dataset.label;

      if (activeContext) {
        lastChangedContextOptions[step + ':' + activeContext] = nextSelected.dataset.value || nextSelected.dataset.label;
      }
    }

    function setActiveContext(step, context, skipSelectionUpdate) {
      var toggles = getStepContextToggles(step);

      if (!toggles.length) {
        return;
      }

      toggles.forEach(function (toggle) {
        var isActive = toggle.dataset.context === context;
        toggle.classList.toggle('is-active', isActive);
        toggle.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      syncContextVisibility(step);

      if (!skipSelectionUpdate) {
        updateSelections();
      }
    }

    function getPrimaryOption(step) {
      var selected = getSelectedOptions(step);
      var lastValue = lastChangedOptions[step];

      if (!selected.length) {
        return null;
      }

      if (lastValue) {
        var matched = selected.find(function (option) {
          return (option.dataset.value || option.dataset.label) === lastValue;
        });

        if (matched) {
          return matched;
        }
      }

      return selected[selected.length - 1];
    }

    function syncCarousel(carousel) {
      var track = carousel.querySelector('[data-config-carousel-track]');
      var prevControl = carousel.querySelector('[data-config-carousel-prev]');
      var nextControl = carousel.querySelector('[data-config-carousel-next]');

      if (!track || !prevControl || !nextControl) {
        return;
      }

      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      prevControl.disabled = track.scrollLeft <= 2;
      nextControl.disabled = track.scrollLeft >= maxScroll;
    }

    function scrollCarousel(carousel, direction) {
      var track = carousel.querySelector('[data-config-carousel-track]');

      if (!track) {
        return;
      }

      track.scrollBy({
        left: Math.max(track.clientWidth * 0.85, 280) * direction,
        behavior: 'smooth',
      });
    }

    function buildProperties() {
      if (!orderForm) {
        return {};
      }

      return Array.prototype.slice
        .call(orderForm.querySelectorAll('input[name^="properties["]'))
        .reduce(function (properties, input) {
          var match = input.name.match(/^properties\[(.*)\]$/);

          if (!match) {
            return properties;
          }

          properties[match[1]] = input.value;
          return properties;
        }, {});
    }

    function getBasePreviewImage() {
      var selectedColor = getPrimaryOption('color');

      if (selectedColor && selectedColor.dataset.image) {
        return selectedColor.dataset.image;
      }

      if (stageImage) {
        return stageImage.currentSrc || stageImage.getAttribute('src') || '';
      }

      return '';
    }

    function buildCartItems() {
      if (!orderForm) {
        return [];
      }

      var variantInput = orderForm.querySelector('input[name="id"]');
      var quantityInput = orderForm.querySelector('input[name="quantity"]');
      var baseVariantId = Number(variantInput && variantInput.value);
      var quantity = Math.max(1, Number(quantityInput && quantityInput.value) || 1);
      var bundleKey = 'stark-configurator-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
      var baseProperties = buildProperties();
      var basePreviewImage = getBasePreviewImage();
      var items = [];
      var addOnItems = {};
      var missingPaidSelections = [];

      baseProperties._stark_configurator_base = 'true';
      baseProperties._stark_configurator_bundle = bundleKey;

      if (basePreviewImage) {
        baseProperties._stark_configurator_preview_image = basePreviewImage;
      }

      if (baseVariantId) {
        items.push({
          id: baseVariantId,
          quantity: quantity,
          properties: baseProperties,
        });
      }

      options.forEach(function (option) {
        if (!option.classList.contains('is-selected')) {
          return;
        }

        var price = Number(option.dataset.price || 0);
        var addOnVariantId = option.dataset.addonVariantId;
        var addOnKey = option.dataset.label || option.dataset.value || 'Addon';

        if (price <= 0) {
          return;
        }

        if (!addOnVariantId) {
          missingPaidSelections.push(addOnKey);
          return;
        }

        if (!addOnItems[addOnVariantId]) {
          addOnItems[addOnVariantId] = {
            id: Number(addOnVariantId),
            quantity: 0,
            properties: {
              _stark_configurator_addon: 'true',
              _stark_configurator_bundle: bundleKey,
              _stark_configurator_selection: addOnKey,
              _stark_configurator_parent_variant: String(baseVariantId || ''),
              _stark_configurator_preview_image: option.dataset.stageImage || option.dataset.image || '',
            },
          };
        }

        addOnItems[addOnVariantId].quantity += quantity;
      });

      if (missingPaidSelections.length) {
        throw new Error('Missing Shopify add-on mapping for: ' + missingPaidSelections.join(', '));
      }

      return items.concat(
        Object.keys(addOnItems).map(function (key) {
          return addOnItems[key];
        })
      );
    }

    function updateStage() {
      var activeStep = getStepOrder()[activeStepIndex];
      var selectedColor = getPrimaryOption('color');
      var selectedBrake = getPrimaryOption('rear_brake');
      var selectedPower = getPrimaryOption('power');
      var selectedSuspension = getPrimaryOption('suspension');
      var selectedSidestand = getPrimaryOption('sidestand');
      var activeOption = getPrimaryOption(activeStep);

      if (!selectedColor || !stageImage) {
        return;
      }

      if (stageOverlay) {
        stageOverlay.hidden = true;
      }

      if (stagePower) {
        stagePower.hidden = true;
      }

      if (activeStep === 'power') {
        stageImage.src = (selectedPower && selectedPower.dataset.stageImage) || selectedColor.dataset.image;
        if (stagePower && stagePowerValue) {
          stagePower.hidden = false;
          stagePowerValue.textContent = (selectedPower && (selectedPower.dataset.display || selectedPower.dataset.label)) || '60HP';
        }
        return;
      }

      if (activeStep === 'rear_brake') {
        stageImage.src = (selectedBrake && selectedBrake.dataset.stageImage) || selectedColor.dataset.image;
        if (stageOverlay && selectedColor.dataset.handguardImage) {
          stageOverlay.src = selectedColor.dataset.handguardImage;
          stageOverlay.hidden = false;
        }
        return;
      }

      if (activeStep === 'suspension') {
        stageImage.src = (selectedSuspension && selectedSuspension.dataset.stageImage) || selectedColor.dataset.image;
        return;
      }

      if (activeOption && activeOption.dataset.stageImage) {
        stageImage.src = activeOption.dataset.stageImage;
        return;
      }

      stageImage.src = selectedColor.dataset.image;
    }

    function setActiveStep(step) {
      activeStepIndex = Math.max(0, getStepOrder().indexOf(step));
      var activeTab = tabs[activeStepIndex];

      tabs.forEach(function (tab) {
        var isActive = tab.dataset.configTab === step;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.dataset.stepPanel === step;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      if (prevButton) {
        prevButton.disabled = activeStepIndex <= 0;
      }

      if (nextButton) {
        nextButton.disabled = activeStepIndex >= tabs.length - 1;
      }

      updateStage();
      requestStarkConfiguratorOrderOffsetUpdate();
      requestHorizontalRowsSync();

      if (activeTab) {
        window.requestAnimationFrame(function () {
          scrollIntoConfiguratorView(activeTab);
        });
      }
    }

    function updateSelections() {
      var total = basePrice;
      var summaryItems = [];
      var stepOrder = getStepOrder().filter(function (step) {
        return step !== 'summary';
      });

      stepOrder.forEach(function (step) {
        var selected = getSelectedOptions(step);
        var selectedLabels = selected.map(function (option) {
          return option.dataset.label;
        });
        var selectedPrice = selected.reduce(function (sum, option) {
          return sum + Number(option.dataset.price || 0);
        }, 0);
        var input = configurator.querySelector('[data-property-input="' + step + '"]');
        var choiceTarget = configurator.querySelector('[data-current-choice="' + step + '"]');

        if (selected.length > 0) {
          total += selectedPrice;
          summaryItems.push({
            key: formatStepLabel(step),
            value: selectedLabels.join(', '),
            price: selectedPrice,
          });
        }

        if (input) {
          input.value = selectedLabels.join(', ');
        }

        if (choiceTarget) {
          choiceTarget.textContent = selectedLabels.join(', ');
        }
      });

      var totalInput = configurator.querySelector('[data-property-input="estimated-total"]');
      if (totalInput) {
        totalInput.value = formatMoney(total, currencyCode);
      }

      totalTargets.forEach(function (target) {
        target.textContent = formatMoney(total, currencyCode);
      });

      if (leasingTotalInput) {
        leasingTotalInput.value = String(total);
        leasingTotalInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      summaryTargets.forEach(function (target) {
        target.innerHTML = buildSummaryMarkup(summaryItems, currencyCode);
      });

      var selectedColor = getPrimaryOption('color');
      var selectedBrake = getPrimaryOption('rear_brake');
      var selectedPower = getPrimaryOption('power');
      var selectedSuspension = getPrimaryOption('suspension');
      var selectedSidestand = getPrimaryOption('sidestand');

      if (selectedColor && summaryImages.color) {
        summaryImages.color.src = selectedColor.dataset.image;
      }

      if (summaryImages.power) {
        summaryImages.power.src = (selectedPower && selectedPower.dataset.stageImage) || (selectedColor && selectedColor.dataset.image) || '';
      }

      if (summaryImages.rear_brake) {
        summaryImages.rear_brake.src = (selectedBrake && selectedBrake.dataset.stageImage) || (selectedColor && selectedColor.dataset.image) || '';
      }

      if (summaryImages.suspension) {
        summaryImages.suspension.src = (selectedSuspension && selectedSuspension.dataset.stageImage) || (selectedColor && selectedColor.dataset.image) || '';
      }

      if (summaryImages.sidestand) {
        summaryImages.sidestand.src = (selectedSidestand && selectedSidestand.dataset.stageImage) || (selectedColor && selectedColor.dataset.image) || '';
      }

      updateStage();
      requestStarkConfiguratorOrderOffsetUpdate();
      configurator.dispatchEvent(
        new CustomEvent('stark-configurator:updated', {
          bubbles: true,
          detail: { totalCents: total },
        })
      );
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        var step = option.dataset.step;
        var isMultiple = option.dataset.multiple === 'true';
        var optionKey = option.dataset.value || option.dataset.label;

        if (option.dataset.context && option.dataset.context !== getActiveContext(step)) {
          setActiveContext(step, option.dataset.context, true);
        }

        if (isMultiple) {
          option.classList.toggle('is-selected');
        } else {
          options.forEach(function (candidate) {
            if (candidate.dataset.step === step) {
              candidate.classList.remove('is-selected');
            }
          });
          option.classList.add('is-selected');
        }

        if (option.classList.contains('is-selected')) {
          lastChangedOptions[step] = optionKey;
          if (option.dataset.context) {
            lastChangedContextOptions[step + ':' + option.dataset.context] = optionKey;
          }
        } else if (lastChangedOptions[step] === optionKey) {
          delete lastChangedOptions[step];
        }

        updateSelections();

        window.requestAnimationFrame(function () {
          scrollIntoConfiguratorView(option);
          requestHorizontalRowsSync();
        });
      });
    });

    contextToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (toggle.classList.contains('is-active')) {
          return;
        }

        setActiveContext(toggle.dataset.step, toggle.dataset.context);

        window.requestAnimationFrame(function () {
          scrollIntoConfiguratorView(toggle);
          requestHorizontalRowsSync();
        });
      });
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActiveStep(tab.dataset.configTab);

        window.requestAnimationFrame(function () {
          carousels.forEach(function (carousel) {
            syncCarousel(carousel);
          });
        });
      });
    });

    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-config-carousel-track]');
      var prevControl = carousel.querySelector('[data-config-carousel-prev]');
      var nextControl = carousel.querySelector('[data-config-carousel-next]');

      if (!track || !prevControl || !nextControl) {
        return;
      }

      prevControl.addEventListener('click', function () {
        scrollCarousel(carousel, -1);
      });

      nextControl.addEventListener('click', function () {
        scrollCarousel(carousel, 1);
      });

      track.addEventListener('scroll', function () {
        syncCarousel(carousel);
      });

      if (typeof ResizeObserver === 'function') {
        var resizeObserver = new ResizeObserver(function () {
          syncCarousel(carousel);
        });

        resizeObserver.observe(track);
      }

      window.addEventListener('resize', function () {
        syncCarousel(carousel);
      });

      syncCarousel(carousel);

      window.setTimeout(function () {
        syncCarousel(carousel);
      }, 150);
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        var stepOrder = getStepOrder();
        setActiveStep(stepOrder[Math.max(activeStepIndex - 1, 0)]);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        var stepOrder = getStepOrder();
        setActiveStep(stepOrder[Math.min(activeStepIndex + 1, stepOrder.length - 1)]);
      });
    }

    if (orderForm && typeof window.fetch === 'function') {
      orderForm.addEventListener('submit', function (event) {
        var originalButtonText;
        var items;

        event.preventDefault();

        try {
          items = buildCartItems();
        } catch (error) {
          window.alert(error.message || 'Unable to prepare this configuration for checkout.');
          return;
        }

        if (!items.length) {
          orderForm.submit();
          return;
        }

        if (orderButton) {
          originalButtonText = orderButton.textContent;
          orderButton.disabled = true;
          orderButton.textContent = 'Adding...';
        }

        window
          .fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items: items }),
          })
          .then(function (response) {
            if (response.ok) {
              return response.json();
            }

            return response.json().catch(function () {
              return null;
            }).then(function (payload) {
              var description = payload && (payload.description || payload.message);
              throw new Error(description || 'Unable to add this configuration to the cart.');
            });
          })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function (error) {
            if (orderButton) {
              orderButton.disabled = false;
              orderButton.textContent = originalButtonText || 'Order now';
            }

            window.alert(error.message || 'Unable to add this configuration to the cart.');
          });
      });
    }

    propertyInputs.forEach(function (input) {
      if (input.dataset.propertyInput === 'estimated-total') {
        input.value = formatMoney(basePrice, currencyCode);
      }
    });

    contextToggles.forEach(function (toggle) {
      if (toggle.classList.contains('is-active')) {
        setActiveContext(toggle.dataset.step, toggle.dataset.context, true);
      }
    });

    var initialStep = tabs.some(function (tab) {
      return tab.dataset.configTab === 'color';
    })
      ? 'color'
      : (tabs[0] && tabs[0].dataset.configTab) || 'summary';

    setActiveStep(initialStep);
    updateSelections();
    requestStarkConfiguratorOrderOffsetUpdate();
    requestHorizontalRowsSync();

    window.addEventListener('resize', requestHorizontalRowsSync);
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-stark-configurator]')).forEach(initConfigurator);
  });
})();